export default {
  loans: null
};